/* Built In Imports */
import { useContext, useEffect } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import CardFilter from '@components/Filters/CardFilter';
import MMMBanner from '@components/HeaderBanner/MMMBanner';
import Breadcrum from '@components/Navigation/Breadcrum';
import MeetSadhguru from '@components/Sliders/MeetSadhguru';
import HeadComponent from '@components/Utility/HeadComponent';
import config from '@config';
import WrapLayout from '@Layout/WrapLayout';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData, fetchHeaderMenuData, fetchHeaderTopMenuData
} from 'services/commonService';
import {
  fetchSadhguruMMMPage,
  getSadhguruLandingPaths
} from 'services/sadhguruService';

/* Styles */
import classes from '@styles/pages/ManPage.module.css';

/**
 *
 * @param headerMenuData
 * @param region
 * @param language
 * @param footerData
 * @param pageData
 * @param mmmSection
 * @param page
 */
export default function Page({
  headerMenuData,
  region,
  language,
  footerData,
  pageData,
  mmmSection,
  page,
}) {
  // const [currentUserRegion, setCurrentUserRegion] = useState(region);
  // const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  // const [regionDropdownOpen, setRegionDropdownOpen] = useState(false);
  const authContext = useContext(AuthContext);
  // authContext.RegionAndLang(region, language);

  useEffect(() => {
    authContext.RegionAndLang(region, language);
    // let currentRegion = config.locales.find(
    //   locale => locale.region_sf === region
    // ).region;
    // setCurrentUserRegion(currentRegion);
  }, [authContext, region, language]);

  return (
    <WrapLayout>
      <HeadComponent
        data={pageData?._seoMetaTags || pageData?.seoFields}
        availableLocals={pageData.availableLocales}
      >
        {' '}
      </HeadComponent>
      <Breadcrum
        page={pageData.breadcrumbs}
        alsoin={pageData.alsoin}
        url=""
        region={region}
        lang={language}
        pageConfig={pageData?.pageConfig}
      />
      <section className="container">
        <Box maxWidth="1300px" m="0 auto">
          <Box bgColor="rgb(239 237 232 / 54%)" float="left" w="100%">
            <MMMBanner
              title={pageData.bannerSection && pageData.bannerSection[0].title}
              desc={pageData.bannerSection && pageData.bannerSection[0].body}
              mobileImg={
                pageData.bannerSection &&
                  pageData.bannerSection[0].mobileBannerImage
                  ? pageData.bannerSection[0].mobileBannerImage['url']
                  : `${config.imgPath}/sites/default/files/2018-05/mission-header2.jpg`
                /*'https://images.sadhguru.org/sites/default/files/2018-05/mission-header2.jpg'*/
              }
              desktopImg={
                pageData.bannerSection &&
                pageData.bannerSection[0] &&
                pageData.bannerSection[0].desktopBannerImage &&
                pageData.bannerSection[0].desktopBannerImage['url']
              }
              lang={language}
              page={page}
            />

            <section className={classes['filter-section']}>
              <Box
                p={{ sm: '0px 0px', md: '0px 16px', lg: '0px 16px' }}
                w={{ base: '91%', lg: '100%' }}
                m="20px auto"
                float="none"
                pt={{ base: '5vw', lg: '0' }}
              >
                <CardFilter
                  posts={pageData.posts}
                  mmmSection={mmmSection}
                  contentTypes={pageData.contentTypes}
                  page={page}
                  region={region}
                  lang={language}
                />
              </Box>
            </section>
            <Box
              float="left"
              w="100%"
            // className={classes["meet-section"]}
            >
              {pageData.meet_sadhguru?.results != 0 ? (
                <MeetSadhguru
                  meetData={
                    pageData?.meet_sadhguru && pageData.meet_sadhguru?.results
                  }
                />
              ) : (
                ''
              )}
            </Box>
          </Box>
        </Box>
      </section>
      {/* <Footer region={region} language={language} footerData={footerData} />
      <BottomWidget region={region} /> */}
    </WrapLayout>
  ); // added extra to work app
}

export const getStaticPaths = async () => {
  const mmmNewPaths = config.USE_LOCAL_URL
    ? [`/en/sadhguru/man`, `/te/sadhguru/man`]
    : await getSadhguruLandingPaths('L1', '/sadhguru/');
  return {
    paths: mmmNewPaths,
    fallback: false,
  };
};

export const getStaticProps = async ({
  preview,
  previewData,
  params: { region, mmm },
  req,
}) => {
  // let ipRegion = await getCurrentIpRegion();
  const language = region;

  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale('', language),
    'isotopmenu'
  );

  const headerMenuData = await fetchHeaderMenuData(
    getLocale('', language),
    'iso_non_regional_menu'
  );
  const footerData = await fetchFooterData(
    getLocale('', language),
    'isofooter'
  );
  const pageData = await fetchSadhguruMMMPage('', language, mmm, {
    preview,
    data: previewData,
  });

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region: '',
      language: language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      mmmSection: mmm,
      page: mmm,
      isPreview: preview ? true : false
    }
  };
};
